import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../../services/http.service';
import {GridService} from '../../../services/grid.service';

@Component({
  selector: 'app-ai-learn-data-actions',
  templateUrl: './ai-learn-data-actions.component.html',
  styleUrls: ['./ai-learn-data-actions.component.scss']
})
export class AiLearnDataActionsComponent implements OnInit {
  private params!: ICellRendererParams;
  public value: string = ''
  constructor(
    private httpService: HttpService,
    private gridService: GridService
  ) { }

  ngOnInit(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = this.params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  onDelete() {
    if (confirm('Are you sure?')) {
      this.httpService.post(environment.API_PATH + `/ai/deleteLearnData/${this.params.data._id}`, {}).subscribe(res => {
        this.gridService.aiLearGridEvent.next(true);
      });
    }
  }

}
